import * as React from 'react';

const ExclamationCircleFilled64 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 64 64", width: 64, height: 64, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M32 58.67c14.73 0 26.67-11.94 26.67-26.67C58.67 17.27 46.73 5.33 32 5.33 17.27 5.33 5.33 17.27 5.33 32c0 14.73 11.94 26.67 26.67 26.67ZM30.51 18h3.01v19.002h-3.01V18Zm1.5 22.25c1.39 0 2.52 1.13 2.52 2.52 0 1.39-1.13 2.52-2.52 2.52-1.39 0-2.52-1.13-2.52-2.52 0-1.39 1.13-2.52 2.52-2.52Z"
  }
));
ExclamationCircleFilled64.Size = 64;
ExclamationCircleFilled64.Title = "ExclamationCircleFilled";

export { ExclamationCircleFilled64 as default };
